export default __webpack_public_path__ + "static/media/Aura-Egg__23.5d9bbd99.png";